import { render, staticRenderFns } from "./UdeQuestionForm.vue?vue&type=template&id=a37f07b6&scoped=true"
import script from "./UdeQuestionForm.vue?vue&type=script&lang=js"
export * from "./UdeQuestionForm.vue?vue&type=script&lang=js"
import style0 from "./UdeQuestionForm.vue?vue&type=style&index=0&id=a37f07b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37f07b6",
  null
  
)

export default component.exports